import axios from '@/libs/api.request'

// api/mapping.js
export const getMappingData = async (that, data) => {
    let res = await axios.request({
        url: '/shop/medium_mapping/getMappingList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({ name: 'login' });
        }
        return;
    }
    return res;
};


export const getInterList = async (that, data) => {
    let res = await axios.request({
        url: '/shop/medium_mapping/getInterList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({ name: 'login' });
        }
        return;
    }
    return res;
}

export const saveInter = async (that, data) => {
    let res = await axios.request({
        url: '/shop/medium_mapping/saveInter',
        data,
        method: 'post'
    })
    return res.data;
}

export const delInter = async (that, data) => {
    let res = await axios.request({
        url: '/shop/medium_mapping/delMapping',
        data,
        method: 'post'
    })
    return res.data;
}